import styled from "styled-components";

export const InputFileMessage = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xx_small }px;

  padding: ${({ theme }) => theme.spacing.xx_small }px;
  border-radius: ${({ theme }) => theme.border_radius.medium }px;
  border: 1px solid ${({ theme }) => theme.glass.border };
  color: ${({ theme }) => theme.colors.text.default };
  background-color: ${({ theme }) => theme.glass.elevated };
  backdrop-filter: ${({ theme }) => theme.glass.blur };

  & > span {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
  }

  & > input {
    position: absolute;
    inset: 0;
    color: transparent;
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
  }

  & > input::file-selector-button {
    opacity: 0;
  }

  & > input:focus {
    border-color: ${({ theme }) => theme.colors.info.default };
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.info.default }33;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.xx_small }px;

  & > div.info-view {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.x_small }px;

    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;
  }

  & > div.info-view > span:first-of-type {
    color: ${({ theme }) => theme.colors.text.default };
  }

  & > div.info-view > span:last-of-type {
    color: ${({ theme }) => theme.colors.gray[ 100 ]};

    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
  }
`;

export const SelectedContact = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.xx_small }px;

  & > div.info-view {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.x_small }px;

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }

  & > div.info-view > span:first-of-type {
    color: ${({ theme }) => theme.colors.text.default };
  }

  & > div.info-view > span:last-of-type {
    color: ${({ theme }) => theme.colors.gray[ 100 ]};

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }
`;
